









































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { debounce } from 'quasar'
import latinize from 'latinize'
import stringCompare from 'src/assets/stringCompare'
import PullAndScroll from 'components/PullAndScroll.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import ContactEditor from 'components/contact/Editor.vue'
import GroupEditor from 'components/contact/GroupEditor.vue'
import ButtonAdd from 'components/contact/ButtonAdd.vue'
import ButtonDelete from 'components/contact/ButtonDelete.vue'
import ButtonGroupAdd from 'components/contact/ButtonGroupAdd.vue'
import ButtonGroupDelete from 'components/contact/ButtonGroupDelete.vue'
import ButtonGroupFilter from 'components/contact/ButtonGroupFilter.vue'
import api from 'src/assets/api/gql'
import ContactsList from 'src/graphql/contact/ContactsList.gql'
import ContactGroupsGetAll from 'src/graphql/contact_group/ContactGroupsGetAll.gql'
import { Contact, ContactGroup } from 'src/graphql/types'

@Component({
  components: {
    PullAndScroll,
    PersonAvatar,
    ContactEditor,
    GroupEditor,
    ButtonAdd,
    ButtonDelete,
    ButtonGroupAdd,
    ButtonGroupDelete,
    ButtonGroupFilter
  }
})
export default class PageContacts extends Vue {
  groupsView = false
  groups: ContactGroup[] = []
  groupsFilter = ''
  contacts: Contact[] = []
  contactsSearchQuery = ''
  contactsSearchGroups: number[] = []
  contactsLoading = false
  contactsLoadCursor: string | null = null

  @Ref()
  readonly contactEditor!: ContactEditor

  @Ref()
  readonly groupEditor!: GroupEditor

  @Ref()
  readonly viewport!: PullAndScroll

  get groupsList () {
    return [...this.groups].sort((a ,b) => stringCompare(a.name, b.name))
  }

  get groupsListFiltered () {
    const needle = latinize(this.groupsFilter).toLowerCase()
    return this.groupsList.filter(g => latinize(g.name).toLowerCase().includes(needle))
  }

  get groupsMap () {
    return new Map(this.groupsList.map(g => [g.id.toString(), g]))
  }

  @Watch('contactsSearchQuery')
  nameSearch () {
    this.reload()
  }

  @Watch('contactsSearchGroups')
  groupsSearch () {
    this.reload()
  }

  created () {
    this.load = debounce(this.load, 1000)
  }

  toggleView () {
    if (this.groupsView) {
      this.groupsView = false
    } else {
      this.groupsView = true
      this.groupsFilter = ''
    }
  }

  async refresh (done: () => void) {
    this.contactsLoading = true
    this.contacts = []
    this.groups = []
    const { data: { contactGroups } } = await api.query({
      query: ContactGroupsGetAll
    })
    if (contactGroups.nodes) {
      this.groups = contactGroups.nodes as ContactGroup[]
      const valid = new Set(this.groups.map(g => g.id))
      this.contactsSearchGroups = this.contactsSearchGroups.filter(id => valid.has(id))
    } else {
      this.contactsSearchGroups = []
    }
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    const { data: { contacts } } = await api.query({
      query: ContactsList,
      variables: {
        name: this.contactsSearchQuery || null,
        groups: this.contactsSearchGroups.length ? this.contactsSearchGroups : null,
        after: this.contactsLoadCursor
      }
    })
    if (contacts.nodes) {
      this.contacts.push(...contacts.nodes as Contact[])
    }
    this.contactsLoadCursor = contacts.pageInfo.hasNextPage ? contacts.pageInfo.endCursor : null
    done(!this.contactsLoadCursor)
    this.contactsLoading = false
  }

  reload () {
    this.contacts = []
    this.contactsLoadCursor = null
    this.contactsLoading = true
    this.$nextTick(() => {
      this.viewport.loader.resume()
      this.viewport.loader.poll()
    })
  }

  contactRemoved (contact: Contact) {
    this.contacts.splice(this.contacts.indexOf(contact), 1)
  }

  groupRemoved (group: ContactGroup) {
    this.groups.splice(this.groups.indexOf(group), 1)
    const searchGroupIndex = this.contactsSearchGroups.indexOf(group.id)
    if (searchGroupIndex !== -1) {
      this.contactsSearchGroups.splice(searchGroupIndex, 1)
    }
  }
}
